var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 122.3H18L31.1 58.5999C31.3533 57.0965 32.1193 55.7273 33.2677 54.7247C34.4161 53.7221 35.8763 53.148 37.4 53.0999H132.8C136.1 53.0999 138.6 56.3999 137.9 59.8999L125.1 122.3Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 122.3V27.7H48.3L54.2 37.9H118.1C118.713 37.8998 119.319 38.022 119.884 38.2594C120.448 38.4968 120.96 38.8446 121.389 39.2824C121.817 39.7202 122.154 40.2392 122.379 40.8089C122.604 41.3786 122.713 41.9875 122.7 42.5999V49.2999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderEmpty);
export default __webpack_public_path__ + "static/media/folder_empty.1f502cf9c0ba5fffbbd32feaadc77b55.svg";
export { ForwardRef as ReactComponent };